import { useTranslation } from "react-i18next";
import React, { useContext, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { MattressBuilderContext } from "./BedSizeSelector/MattressBuilderContext";
import BedSizeSelectorContent from "./BedSizeSelector/BedSizeSelectorContent";

import SaveForLaterModal from "../../components/Modal/SaveForLaterModal";

import BedBuilderContentStep1 from "./common/BedBuilderContentStep1";
import BedBuilderContentStep2 from "./common/BedBuilderContentStep2";
import SingleBedBuilderContentStep2 from "./SingleBedBuilder/SleepStyle/SingleBedBuilderContentStep2";

import {
  currentStackSelector,
  currentStepDoubleSleeperMattressBuilderSelector,
  currentStepGeneralSelector,
  currentStepSingleSleeperMattressBuilderSelector,
  isSaveForLaterModalOpenSelector,
  saveForLaterModalSeenSelector,
  setIsSaveForLaterModalOpen,
  setSaveForLaterModalSeen,
} from "../../redux/slices/customNavigation";
import { isSingleSleeperSelector } from "../../redux/slices/mattressConfiguration";

import BedBuilderContentStep3 from "./common/BedBuilderContentStep3";
import BedBuilderContentStep4 from "./common/BedBuilderContentStep4";
import BedBuilderContentStep5 from "./common/BedBuilderContentStep5";

import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //overflow: auto;
`;

const MattressBuilderContentWizard = () => {
  const dispatch = useDispatch();
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const currentStepGeneral = useSelector(currentStepGeneralSelector);
  const isSaveForLaterModalOpen = useSelector(isSaveForLaterModalOpenSelector);
  const saveForLaterModalSeen = useSelector(saveForLaterModalSeenSelector);
  const currentStepSingleSleeperMattressBuilder = useSelector(
    currentStepSingleSleeperMattressBuilderSelector
  );
  const currentStepDoubleSleeperMattressBuilder = useSelector(
    currentStepDoubleSleeperMattressBuilderSelector
  );

  const currentStack = useSelector(currentStackSelector);

  const generalSteps = [
    {
      component: () => <BedSizeSelectorContent></BedSizeSelectorContent>,
    },
    {
      component: () => <BedSizeSelectorContent></BedSizeSelectorContent>,
    },
  ];
  const singleSleeperSteps = [
    {
      component: () => <BedBuilderContentStep1></BedBuilderContentStep1>,
    },
    {
      component: () => <BedBuilderContentStep1></BedBuilderContentStep1>,
    },
    {
      component: () => <BedBuilderContentStep2></BedBuilderContentStep2>,
    },
    {
      component: () => <BedBuilderContentStep3></BedBuilderContentStep3>,
    },
    {
      component: () => <BedBuilderContentStep4></BedBuilderContentStep4>,
    },
    {
      component: () => <BedBuilderContentStep5></BedBuilderContentStep5>,
    },
  ];
  const doubleSleeperSteps = [
    {
      component: () => <BedBuilderContentStep1></BedBuilderContentStep1>,
    },
    {
      component: () => <BedBuilderContentStep1></BedBuilderContentStep1>,
    },
    {
      component: () => <BedBuilderContentStep2></BedBuilderContentStep2>,
    },
    {
      component: () => <BedBuilderContentStep3></BedBuilderContentStep3>,
    },
    {
      component: () => <BedBuilderContentStep4></BedBuilderContentStep4>,
    },
    {
      component: () => <BedBuilderContentStep5></BedBuilderContentStep5>,
    },
  ];

  useEffect(() => {
    if (!saveForLaterModalSeen) {
      setTimeout(() => {
        return dispatch(setIsSaveForLaterModalOpen(true));
      }, 1500);
    }
  }, []);

  const { t } = useTranslation();
  const GeneralComponent = generalSteps[currentStepGeneral]?.component;
  const SingleSleeperComponent =
    singleSleeperSteps[currentStepSingleSleeperMattressBuilder]?.component;
  const DoubleSleeperComponent =
    doubleSleeperSteps[currentStepDoubleSleeperMattressBuilder]?.component;

  return (
    <>
      {isLargeScreen && (
        <StyledContentContainer
          className="col-9 col-lg-6 col-xl-8 mr-3"
          // style={{height: "95vh"}}
        >
          {!saveForLaterModalSeen && (
            <SaveForLaterModal
              // open={isSaveForLaterModalOpen}
              open={isSaveForLaterModalOpen ? isSaveForLaterModalOpen : false}
              toggleModal={state => {
                dispatch(setIsSaveForLaterModalOpen(state));
                dispatch(setSaveForLaterModalSeen(true));
              }}
            />
          )}
          {currentStack === "general" && <GeneralComponent></GeneralComponent>}

          {currentStack === "singleSleeper" && (
            <SingleSleeperComponent></SingleSleeperComponent>
          )}
          {currentStack === "doubleSleeper" && (
            <DoubleSleeperComponent></DoubleSleeperComponent>
          )}
        </StyledContentContainer>
      )}
    </>
  );
};

export default MattressBuilderContentWizard;
